import { get } from 'lodash';
import cmsAbstractMixin from 'framework/mixins/cms/cms-abstract';


export default {
    mixins: [
        cmsAbstractMixin,
    ],
    props: {
        container: Object,
    },
    data() {
        return {
            cmsCfg: {
                watchPath: 'container.cms',
                type: 'placeholder',
            },
        };
    },
    computed: {
        plugins() {
            return get(this, 'container.plugins', []);
        },
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/mixins/cms/cms-placeholder/index.js